import React, { RefObject } from 'react';
import { Card, CardContent } from './ui'; 
import {
    Users,
    Code,
    TrendingUp,
  } from 'lucide-react';
interface OpenRolesProps {

}

const OpenRoles = React.forwardRef<HTMLDivElement, OpenRolesProps>((props, ref) => (
  <section className="w-full py-12 md:py-24 lg:py-32 bg-muted flex items-center justify-center" ref={ref}>
    
    <div className="container px-4 md:px-6">
      <h2 className="text-3xl font-bold tracking-tighter md:text-4xl/tight mb-8">Open Roles</h2>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 justify-items-center place-items-center">
        <Card>
          <CardContent className="pt-6">
            <div className="flex flex-col items-start space-y-2">
              <Code className="h-8 w-8 text-primary" />
              <h3 className="text-xl font-semibold">Senior Software Engineer</h3>
              <p className="text-muted-foreground">Join our development team to build cutting-edge trading platforms.</p>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6">
            <div className="flex flex-col items-start space-y-2">
              <TrendingUp className="h-8 w-8 text-primary" />
              <h3 className="text-xl font-semibold">Quantitative Analyst</h3>
              <p className="text-muted-foreground">Develop and optimize trading algorithms using advanced quantitative methods.</p>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6">
            <div className="flex flex-col items-start space-y-2">
              <Users className="h-8 w-8 text-primary" />
              <h3 className="text-xl font-semibold">Client Relations Manager</h3>
              <p className="text-muted-foreground">Manage client accounts and foster strong relationships with our partners.</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  </section>
));

export default OpenRoles;